<template>
	<div class="row q-col-gutter-lg">
		<div id="circularProgressContainer">
			<CircularProgress />			
		</div>
		<div class="col-xs-8" id="pageTitleContainer">
			<div class="text-h4 text-weight-bold" id="pageTitle">{{ $t(title) }}</div>
			<div v-if="description" class="q-py-xs" id="pageDescription">{{ $t(description) }}</div>
		</div>
	</div>
	<q-separator class="q-my-md" id="separator" />

	<div class="text-h5 text-weight-bold" id="summaryTitle">{{ $t('portal_visitDetails') }}</div>
	<q-card flat bordered  id="summaryContent">
		<q-card-section>
			<q-field
				v-if="visitDetails && visitDetails.locationName"
				:label="$t('portal_visitLocation')"
				stack-label
				borderless
				id="summaryField"
			>
				<template v-slot:control>
					<div class="self-center full-width no-outline" id="summaryFieldValue">
						{{ visitDetails.locationName }}
					</div>
				</template>
			</q-field>
			<q-field
				v-if="visitDetails && visitDetails.entryDateLocal"
				:label="$t('portal_entryDate')"
				stack-label
				borderless
				id="summaryField"
			>
				<template v-slot:control>
					<div class="self-center full-width no-outline" id="summaryFieldValue">
						<span class="date-value">{{ portal.getFormattedDate(visitDetails.entryDateLocal) }}</span><span class="local-time">{{' ('+ $t('portal_localTime') + ')' }}</span>
					</div>
				</template>
			</q-field>
			<q-field
				v-if="visitDetails && visitDetails.exitDateLocal"
				:label="$t('portal_exitDate')"
				stack-label
				borderless
				id="summaryField"
			>
				<template v-slot:control>
					<div class="self-center full-width no-outline" id="summaryFieldValue">
						<span class="date-value">{{ portal.getFormattedDate(visitDetails.exitDateLocal) }}</span><span class="local-time">{{' ('+ $t('portal_localTime') + ')' }}</span>
					</div>
				</template>
			</q-field>
			<q-field
				v-if="visitDetails && visitDetails.escortName"
				:label="$t('portal_escort')"
				stack-label
				borderless
				id="summaryField"
			>
				<template v-slot:control>
					<div class="self-center full-width no-outline" id="summaryFieldValue">
						{{ visitDetails.escortName }}
					</div>
				</template>
			</q-field>
			<q-field
				v-if="visitDetails && visitDetails.notes"
				:label="$t('portal_notes')"
				stack-label
				borderless
				id="summaryField"
			>
				<template v-slot:control>
					<div class="self-center full-width no-outline" id="summaryFieldValue">
						{{ visitDetails.notes }}
					</div>
				</template>
			</q-field>
		</q-card-section>
	</q-card>

	<div class="text-h5 text-weight-bold" id="summaryTitle" v-if="portal.photoData != null">{{ $t('portal_photoCaptureTitle') }}</div>
	<div class="q-mb-md" id="summaryContent" v-if="portal.photoData != null">
		<q-card flat bordered>
			<q-card-section>
				<img id="visitorPhoto" :src="portal.photoData" />
			</q-card-section>
		</q-card>
	</div>

	<div class="text-h5 text-weight-bold" id="summaryTitle" v-if="displayedFields.length">{{ $t('portal_visitorDetails') }}</div>
	<div class="q-mb-md" id="summaryContent" v-if="displayedFields.length">
		<q-card flat bordered v-for="group in groups" :key="group" id="groupContainer">
			<q-card-section class="group-heading" v-if="group">
				<div id="groupTitle" class="text-h6 text-weight-bold">{{ $t(group) }}</div>
			</q-card-section>
			<q-card-section id="fieldsContainer" class="group-body">
				<div v-for="field in displayedFields" :key="field.cdfId">
					<div class="text-list-label" v-if="field.groupName === group && field.typeId === 2 && (field.subTypeId === 7 || field.subTypeId === 5 || field.subTypeId === 4)">{{ $t(field.displayValue) }}</div>
					<q-field
						v-if="field.groupName === group"					
						:label="$t(field.displayValue)"
						stack-label
						borderless
						id="summaryField"
						:class="field.type.toLowerCase()">
						<template v-slot:control>
							<div class="self-center full-width no-outline" id="summaryFieldValue">
								{{ portal.getFieldValue(field) }}
							</div>
						</template>
					</q-field>
				</div>
			</q-card-section>
		</q-card>
	</div>

	<div class="text-h5 text-weight-bold"  id="summaryTitle">{{ $t('portal_inductionsSummary') }}</div>
	<q-card flat bordered>
		<q-card-section>
			<div class="q-gutter-sm"  id="summaryContent">
				<div class="row" v-if="portal.dataPolicyRequired===true">
					<div class="col-xs-7 col-sm-5" id="dataPolicyTitle">{{ $t('portal_dataPolicyTitle') }}</div>
					<div class="q-mx-md">-</div>
					<div class="col-xs-3 col-sm-3" id="dataPolicyActionSelected">{{ portal.dataPolicyAgreed ? $t('portal_btnAgree') : $t('portal_btnDisagree') }}</div>
				</div>
				<div class="row" v-for="induction in inductions" :key="induction.competencyId">
					<div class="col-xs-7 col-sm-5" id="inductionTitle">{{ $t(induction.inductionTitle) }}</div>
					<div class="q-mx-md">-</div>
					<div class="col-xs-3 col-sm-3" id="inductionActionSelected">{{ induction.isCompleted === null ? $t('portal_btnSkip') : induction.isCompleted ? $t(induction.agreeButtonText) : $t(induction.disagreeButtonText) }}</div>
				</div>
			</div>		
		</q-card-section>	
	</q-card>	
</template>

<style lang="less" scoped src="./confirm-page.less"></style>
<script lang="ts" src="./confirm-page.ts"></script>
